import { IFacetOption } from 'shared/types/ConstructorFacet';

const TEN_THOUSAND_CENTS = 1000000;

export const getPriceRangeFromBucket = (options: Array<IFacetOption>): [number, number] => {
  const firstOption = options[0];
  const lastOption = options[options.length - 1];

  const min = firstOption?.range?.[0];
  let max = lastOption?.range?.[1];

  if (max === 'inf') {
    max = TEN_THOUSAND_CENTS;
  }

  return [Number(min), Number(max)];
};

export const transformBucketValueToRange = (arr: Array<string>): [number, number] => {
  const str = arr[0];
  if (!str) return;

  const parsedValues = str.split('-');

  if (parsedValues?.length !== 2) return;

  if (parsedValues[1] === 'inf') {
    return [Number(parsedValues[0]), TEN_THOUSAND_CENTS];
  }

  return [Number(parsedValues[0]), Number(parsedValues[1])];
};

export const transformArrayToPriceBucketValue = (arr: [number, number]): string => {
  if (arr.length !== 2) return;

  if (arr[1] === TEN_THOUSAND_CENTS) {
    return `${arr[0]}-inf`;
  }

  return `${arr[0]}-${arr[1]}`;
};

/**
 * [shouldShowPlusSign] if the upper bound is 'inf' or 10,000 we need to show the + sign
 * @param arr (eg: ['100-9900'])
 */
export const shouldShowPlusSign = (arr: Array<string>) => {
  const str = arr[0];

  if (!str) {
    // when no filters are applied, we want default to show +
    return true;
  }

  if (str === '500000-1000000') {
    return false;
  }

  const parsedValues = str.split('-');
  return parsedValues[1] === 'inf' || Number(parsedValues[1]) === TEN_THOUSAND_CENTS;
};
